import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ServiceStatus } from 'src/app/model/page/service-status';
import { ServiceStatusPage } from 'src/app/model/page/service-status-page';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

declare let google: any;

@Component({
  selector: 'app-service-status-page',
  templateUrl: './service-status-page.component.html',
  styleUrls: ['./service-status-page.component.scss']
})
export class ServiceStatusPageComponent implements OnInit, AfterViewChecked {
  serviceStatusPage: ServiceStatusPage = {} as ServiceStatusPage;
  preliveAverageFailureRate = 0;
  liveAverageFailure = 0;
  betaAverageFailure = 0;
  preliveAverageFailureRateRounded = 0;
  bataAverageFailureRateRounded = 0;
  liveAverageFailureRounded = 0;
  serviceStatusError = '';
  servicesArray: any = [];
  showServiceStatus = false;

  ischartLoaded: boolean = false;
  preliveStatus: ServiceStatus[] = [
    {
      serviceName: 'AirShopping',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OfferPrice',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderCancel',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderChange',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderCreate',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },

    {
      serviceName: 'OrderReShop',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },

    {
      serviceName: 'OrderRetrieve',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'SeatAvailability',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'ServiceList',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    }
  ];
  betaStatus: ServiceStatus[] = [
    {
      serviceName: 'AirShopping',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OfferPrice',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderCancel',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderChange',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderCreate',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },

    {
      serviceName: 'OrderReShop',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },

    {
      serviceName: 'OrderRetrieve',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'SeatAvailability',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'ServiceList',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    }
  ];

  liveStatus: ServiceStatus[] = [
    {
      serviceName: 'AirShopping',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OfferPrice',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderCancel',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderChange',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'OrderCreate',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },

    {
      serviceName: 'OrderReShop',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },

    {
      serviceName: 'OrderRetrieve',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'SeatAvailability',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    },
    {
      serviceName: 'ServiceList',
      OKtext: 'Unknown Status',
      failureRate: 0,
      successRate: 0,
      apiFailureRate: 100
    }
  ];
  sandboxStatus: ServiceStatus[] = [];
  preLiveStatusOK = true;
  liveStatusOK = true;
  sandBoxStatusOK = true;
  isMaintenanceBannerDisabled: boolean = false;

  constructor(private contentfulService: ContentfulService, private apiService: ApiService, private auth: entraAuthService, private http: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'service-status') {
        this.serviceStatusPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'Service Status' };

    this.contentfulService.getPageContentResponse(query).then((serviceStatusPage) => {
      this.mapBanner(serviceStatusPage.includes.Entry);
      this.mapCards(serviceStatusPage.includes.Entry);
      this.mapNoteSection(serviceStatusPage.includes.Entry);
      this.mapHtmlTitle(serviceStatusPage.items);

      this.isMaintenanceBannerDisabled = this.serviceStatusPage.card === undefined ? true : false;
      if (this.isMaintenanceBannerDisabled) {
        this.getTestServiceStatus();
      }
    });
  }
  private mapBanner(serviceStatusPageEntries: Entry<any>[]) {
    serviceStatusPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapCards(serviceStatusPageEntries: Entry<any>[]) {
    serviceStatusPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        this.mapEntryToCard(entry);
      });
  }

  private mapNoteSection(serviceStatusPageEntries: Entry<any>[]) {
    serviceStatusPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToNoteSection(entry);
      });
  }

  private mapEntryToNoteSection(entry: Entry<any>) {
    this.serviceStatusPage.note = {
      title: '',
      iconClass: entry.fields['iconClass'] as string,
      body: entry.fields['body'] as string,
      fullTitle: '',
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      noteClass: entry.fields['noteClass'] as string
    };
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.serviceStatusPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.serviceStatusPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url as string
    };
  }

  private mapEntryToCard(entry: Entry<any>) {
    this.serviceStatusPage.card = {
      title: entry.fields['title'] as string,
      order: 0,
      body: entry.fields['shortBody'] as string,
      buttonText: '',
      url: '',
      buttonUrl: '',
      headText: '',
      shortBody: entry.fields['headText'] as string
    };
  }
  async getServiceStatus() {
    this.showServiceStatus = true;
    const apiResponse_Instance_A = await this.apiService.sendGetRequest('/service-status');

    let environmentStatus: any[] = [];
    let apiResponse_Instance: any;
    if (apiResponse_Instance_A.success) {
      apiResponse_Instance = apiResponse_Instance_A;
      apiResponse_Instance_A.success.environmentStatuses.forEach((env: any) => {
        if (env.serviceFailureRates.length > 0) {
          environmentStatus.push(env);
        }
      });
    }
    apiResponse_Instance.success.environmentStatuses = [];
    apiResponse_Instance.success?.environmentStatuses.push(...environmentStatus);

    if (apiResponse_Instance.success) {
      this.handleResponse(apiResponse_Instance.success);
    } else if (apiResponse_Instance.error) {
      this.serviceStatusError = apiResponse_Instance.error.statusText;
      if (apiResponse_Instance.error.status == 401) {
        // localStorage.setItem('redirect_url', '/service/service-status');
        // this.auth.initPingLogin();
      }
      this.showServiceStatus = false;
    }
  }

  handleResponse(res: any) {
    this.showServiceStatus = true;
    res.environmentStatuses.forEach((env: any) => {
      if (env.environment !== null) {
        if (env.environment === 'prelive') {
          this.mapPreliveServiceStatus(env.serviceFailureRates);
          this.mapBetaStatus(env.serviceFailureRates);
        } else if (env.environment === 'prod') {
          this.mapliveServiceStatus(env.serviceFailureRates);
        } else {
          this.mapBetaStatus(env.serviceFailureRates);
        }
      }
    });

    if (!res.environmentStatuses.find((x: any) => x.environment === 'prelive')) {
      let preliveObj;
      preliveObj = {
        serviceName: 'PRELIVE',
        statusArray: this.preliveStatus,
        roundedAverageFailureRate: -1,
        averageFailureRate: -1
      };
      this.servicesArray.push(preliveObj);
    }
    if (!res.environmentStatuses.find((x: any) => x.environment === 'sandbox')) {
      let betaObj;
      betaObj = {
        serviceName: 'BETA',
        statusArray: this.betaStatus,
        roundedAverageFailureRate: -1,
        averageFailureRate: -1
      };
      this.servicesArray.push(betaObj);
    }
  }
  handleError(err: any) {}

  mapPreliveServiceStatus(preliveStatus: any) {
    let totalFailureRate = 0;
    let totalNumServices = 0;
    let preliveObj = {};
    preliveStatus.forEach((item: any) => {
      switch (item.service) {
        case 'ndc-orderchange': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'OrderChange');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-orderreshop': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'OrderReShop');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-airshopping': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'AirShopping');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-ordercreate': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'OrderCreate');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-offerprice': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'OfferPrice');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-seatavailability': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'SeatAvailability');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-ordercancel': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'OrderCancel');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-orderretrieve': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'OrderRetrieve');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
        case 'ndc-servicelist': {
          let itemIndex = this.preliveStatus.findIndex((item) => item.serviceName == 'ServiceList');
          this.preliveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.preliveStatus, itemIndex, item);
          break;
        }
      }
    });

    this.preliveStatus.forEach((item: any) => {
      if (item.OKtext == 'Unknown Status') {
        totalFailureRate += 20;
        totalNumServices += 1;
      } else {
        totalFailureRate += item.failureRate;
        totalNumServices += 1;
      }
    });
    this.preliveAverageFailureRateRounded = Math.round(totalFailureRate / totalNumServices);
    this.preliveAverageFailureRate = totalFailureRate / totalNumServices;
    preliveObj = {
      serviceName: 'PRELIVE',
      statusArray: this.preliveStatus,
      roundedAverageFailureRate: Math.round(totalFailureRate / totalNumServices),
      averageFailureRate: totalFailureRate / totalNumServices
    };
    this.servicesArray[1] = preliveObj;
    if (typeof preliveObj !== 'undefined') {
      this.drawChart(preliveObj, 'Prelive');
    }
  }
  mapBetaStatus(betaStatus: any) {
    let totalFailureRate = 0;
    let totalNumServices = 0;
    let betaObj = {};
    betaStatus.forEach((item: any) => {
      switch (item.service) {
        case 'ndc-orderchange': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'OrderChange');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-orderreshop': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'OrderReShop');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-airshopping': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'AirShopping');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-ordercreate': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'OrderCreate');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-offerprice': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'OfferPrice');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-seatavailability': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'SeatAvailability');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-ordercancel': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'OrderCancel');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-orderretrieve': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'OrderRetrieve');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
        case 'ndc-servicelist': {
          let itemIndex = this.betaStatus.findIndex((item) => item.serviceName == 'ServiceList');
          this.betaStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.betaStatus, itemIndex, item);
          break;
        }
      }
    });

    this.betaStatus.forEach((item: any) => {
      if (item.OKtext == 'Unknown Status') {
        totalFailureRate += 20;
        totalNumServices += 1;
      } else {
        totalFailureRate += item.failureRate;
        totalNumServices += 1;
      }
    });
    this.bataAverageFailureRateRounded = Math.round(totalFailureRate / totalNumServices);
    this.betaAverageFailure = totalFailureRate / totalNumServices;
    betaObj = {
      serviceName: 'BETA',
      statusArray: this.betaStatus,
      roundedAverageFailureRate: Math.round(totalFailureRate / totalNumServices),
      averageFailureRate: totalFailureRate / totalNumServices
    };
    this.servicesArray[2] = betaObj;
    if (typeof betaObj !== 'undefined') {
      this.drawChart(betaObj, 'Beta');
    }
  }

  mapliveServiceStatus(liveStatus: any) {
    let totalFailureRate = 0;
    let totalNumServices = 0;
    let liveObj = {};
    liveStatus.forEach((item: any) => {
      switch (item.service) {
        case 'ndc-orderchange': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'OrderChange');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-orderreshop': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'OrderReShop');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-airshopping': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'AirShopping');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-ordercreate': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'OrderCreate');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-offerprice': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'OfferPrice');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-seatavailability': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'SeatAvailability');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-ordercancel': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'OrderCancel');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-orderretrieve': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'OrderRetrieve');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
        case 'ndc-servicelist': {
          let itemIndex = this.liveStatus.findIndex((item) => item.serviceName == 'ServiceList');
          this.liveStatus[itemIndex].OKtext = this.getStatusText(parseInt(item.failureRate));
          this.getResponseStatus(this.liveStatus, itemIndex, item);
          break;
        }
      }
    });

    this.liveStatus.forEach((item: any) => {
      if (item.OKtext == 'Unknown Status') {
        totalFailureRate += 20;
        totalNumServices += 1;
      } else {
        totalFailureRate += item.failureRate;
        totalNumServices += 1;
      }
    });
    this.liveAverageFailureRounded = Math.round(totalFailureRate / totalNumServices);
    this.liveAverageFailure = totalFailureRate / totalNumServices;
    liveObj = {
      serviceName: 'LIVE',
      statusArray: this.liveStatus,
      roundedAverageFailureRate: Math.round(totalFailureRate / totalNumServices),
      averageFailureRate: totalFailureRate / totalNumServices
    };
    this.servicesArray[0] = liveObj;

    if (typeof liveObj !== 'undefined') {
      this.drawChart(liveObj, 'Live');
    }
  }
  private getTestServiceStatus() {
    // this.sideMenu.links = [];

    const query = { 'fields.title': 'Service Status' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      if (labelItems[0]?.fields.constants) {
        this.handleResponse(labelItems[0]?.fields.constants);
      } else {
        this.getServiceStatus();
      }
    });
  }
  getStatusText(failureRate: any): string {
    let statusText = 'OK';
    if (failureRate === 0) {
      statusText = 'No issues reported';
    } else if (failureRate > 0 && failureRate <= 20) {
      statusText = 'Issue ' + failureRate + '% Errors reported';
    } else if (failureRate > 20 && failureRate <= 80) {
      statusText = 'Error ' + failureRate + '% Errors reported';
    } else if (failureRate > 80 && failureRate <= 100) {
      statusText = 'Error ' + failureRate + '% Errors reported';
    }
    return statusText;
  }

  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }
  drawChart(apiDetails: any, environment: 'Live' | 'Prelive' | 'Beta') {
    google.charts.load('current', { packages: ['bar'] });
    google.charts.setOnLoadCallback(drawChart);
    this.ischartLoaded = true;
    function drawChart() {
      var data = google.visualization.arrayToDataTable([
        [environment + ' ' + 'API', 'Success Rate %', 'Failure Rate %', 'Unknown API Status %', { role: 'annotation' }],
        [apiDetails.statusArray[0].serviceName, apiDetails.statusArray[0].successRate, apiDetails.statusArray[0].failureRate, apiDetails.statusArray[0].apiFailureRate, ''],
        [apiDetails.statusArray[1].serviceName, apiDetails.statusArray[1].successRate, apiDetails.statusArray[1].failureRate, apiDetails.statusArray[1].apiFailureRate, ''],
        [apiDetails.statusArray[2].serviceName, apiDetails.statusArray[2].successRate, apiDetails.statusArray[2].failureRate, apiDetails.statusArray[2].apiFailureRate, ''],
        [apiDetails.statusArray[3].serviceName, apiDetails.statusArray[3].successRate, apiDetails.statusArray[3].failureRate, apiDetails.statusArray[3].apiFailureRate, ''],
        [apiDetails.statusArray[4].serviceName, apiDetails.statusArray[4].successRate, apiDetails.statusArray[4].failureRate, apiDetails.statusArray[4].apiFailureRate, ''],
        [apiDetails.statusArray[5].serviceName, apiDetails.statusArray[5].successRate, apiDetails.statusArray[5].failureRate, apiDetails.statusArray[5].apiFailureRate, ''],
        [apiDetails.statusArray[6].serviceName, apiDetails.statusArray[6].successRate, apiDetails.statusArray[6].failureRate, apiDetails.statusArray[6].apiFailureRate, ''],
        [apiDetails.statusArray[7].serviceName, apiDetails.statusArray[7].successRate, apiDetails.statusArray[7].failureRate, apiDetails.statusArray[7].apiFailureRate, ''],
        [apiDetails.statusArray[8].serviceName, apiDetails.statusArray[8].successRate, apiDetails.statusArray[8].failureRate, apiDetails.statusArray[8].apiFailureRate, '']
      ]);
      const options = {
        width: 1080,
        height: 300,

        legend: { position: 'center' },
        bar: { groupWidth: '55%' },
        isStacked: true,
        vAxis: { format: 'decimal', title: 'Status %' },
        hAxis: {},
        // bars: 'horizontal',
        series: {
          0: { color: '#9be09b' },
          1: { color: '#e60000' },
          2: { color: '#b8b894' }
        }
      };

      if (environment === 'Prelive') {
        const chart = new google.charts.Bar(document.querySelector('#initial_chart_prelive'));
        chart.draw(data, google.charts.Bar.convertOptions(options));
      } else if (environment === 'Beta') {
        const chart = new google.charts.Bar(document.querySelector('#initial_chart_beta'));
        chart.draw(data, google.charts.Bar.convertOptions(options));
      } else if (environment === 'Live') {
        const chart = new google.charts.Bar(document.querySelector('#initial_chart_live'));
        chart.draw(data, google.charts.Bar.convertOptions(options));
      }
    }
  }

  private getResponseStatus(env: ServiceStatus[], itemIndex: number, item: ServiceStatus) {
    if (env[itemIndex].OKtext !== 'Unknown Status') {
      env[itemIndex].successRate = 100 - Math.floor(item.failureRate);
      env[itemIndex].failureRate = Math.floor(item.failureRate);
      env[itemIndex].apiFailureRate = 0;
    } else {
      env[itemIndex].successRate = 0;
      env[itemIndex].apiFailureRate = 100;
    }
  }
}
